import { getIsShowOfferButtonAtBillingPreview } from "./aoiLocalSettings";

const EMPTY_OFFER_GROUP = [];

export const partitionOfferCheckboxData = (checkboxAllData = []) => {
	const groups = {
		"0-0": [],
		"1-0": [],
		"0-1": [],
		"1-1": [],
	};

	checkboxAllData.forEach((item) => {
		const key = `${item.type}-${item.level}`;
		if (groups[key]) {
			groups[key].push(item);
		}
	});

	return groups;
};

export const getOfferCheckboxGroup = (groups, type, level) =>
	groups?.[`${type}-${level}`] ?? EMPTY_OFFER_GROUP;

export const isOfferApplicableOnBill = (billData) => {
	const isShowOfferButton = getIsShowOfferButtonAtBillingPreview();

	return (
		isShowOfferButton == 1 &&
		billData &&
		Object.keys(billData).length !== 0 &&
		Array.isArray(billData.offerHeaders) &&
		billData.offerHeaders.length !== 0
	);
};

export const hasAnyOfferApplicable = (offerBillNewData = []) =>
	(offerBillNewData || []).some((billData) =>
		isOfferApplicableOnBill(billData),
	);

export const buildOfferCheckboxesForBill = (offerBillNewData, billId) => {
	const checkboxData = [];

	(offerBillNewData || []).forEach((offerData) => {
		if (
			Object.keys(offerData.outletBillsAfterApplyingOffers).length !== 0 &&
			offerData.outletBillsAfterApplyingOffers.id == billId &&
			offerData.offerHeaders.length !== 0
		) {
			offerData.offerHeaders.forEach((allOffer) => {
				checkboxData.push({
					...allOffer,
					appliedOfferId: offerData.outletBillsAfterApplyingOffers.id,
				});
			});
		}
	});

	return checkboxData;
};

/**
 * Toggle offer checkbox selection with mutual-exclusion rules by level/type.
 * Preserves existing AOI offer-selection behaviour.
 */
export const toggleOfferCheckboxSelection = (
	checkboxAllData,
	offerBillNewData,
	checkedValue,
	headerId,
) => {
	const checkboxData = [];

	(offerBillNewData || []).forEach((offerData) => {
		if (
			Object.keys(offerData.outletBillsAfterApplyingOffers).length !== 0 &&
			offerData.outletBillsAfterApplyingOffers.id === headerId
		) {
			checkboxAllData.forEach((allOffer) => {
				if (
					allOffer.level == 0 &&
					allOffer.type == 0 &&
					checkedValue.level == 0 &&
					checkedValue.type == 0
				) {
					if (allOffer.id == checkedValue.id) {
						checkboxData.push({
							...allOffer,
							isApplied: allOffer.isApplied == 1 ? 0 : 1,
							appliedOfferId: offerData.outletBillsAfterApplyingOffers.id,
						});
					} else {
						checkboxData.push({
							...allOffer,
							isApplied: allOffer.isApplied == 1 ? 0 : 0,
						});
					}
				} else if (
					allOffer.level == 0 &&
					allOffer.type == 1 &&
					checkedValue.level == 0 &&
					checkedValue.type == 1
				) {
					if (allOffer.id == checkedValue.id) {
						checkboxData.push({
							...allOffer,
							isApplied: allOffer.isApplied == 1 ? 0 : 1,
							appliedOfferId: offerData.outletBillsAfterApplyingOffers.id,
						});
					} else {
						checkboxData.push({
							...allOffer,
							isApplied: allOffer.isApplied == 1 ? 0 : 0,
						});
					}
				} else if (
					allOffer.level == 1 &&
					allOffer.type == 0 &&
					checkedValue.level == 1 &&
					checkedValue.type == 0
				) {
					if (allOffer.id == checkedValue.id) {
						checkboxData.push({
							...allOffer,
							isApplied: allOffer.isApplied == 1 ? 0 : 1,
							appliedOfferId: offerData.outletBillsAfterApplyingOffers.id,
						});
					} else {
						checkboxData.push({
							...allOffer,
							isApplied: allOffer.isApplied,
						});
					}
				} else if (
					allOffer.level == 1 &&
					allOffer.type == 1 &&
					checkedValue.level == 1 &&
					checkedValue.type == 1
				) {
					if (allOffer.id == checkedValue.id) {
						checkboxData.push({
							...allOffer,
							isApplied: allOffer.isApplied == 1 ? 0 : 1,
							appliedOfferId: offerData.outletBillsAfterApplyingOffers.id,
						});
					} else {
						checkboxData.push({
							...allOffer,
							isApplied: allOffer.isApplied,
						});
					}
				} else {
					checkboxData.push(allOffer);
				}
			});
		}
	});

	return checkboxData;
};

export const buildSelectedOffersPayload = ({
	offerBillNewData,
	billOfferId,
	checkboxAllData,
	stockChangedList,
}) => {
	const dataToSave = [];

	(offerBillNewData || []).forEach((billData) => {
		const header = billData.outletBillHeader;
		const hasHeader = header && Object.keys(header).length !== 0;

		if (hasHeader && header.id == billOfferId) {
			const billCheckedOfferData = [];
			if (billData.offerHeaders?.length !== 0) {
				billData.offerHeaders.forEach((offerData) => {
					checkboxAllData.forEach((checkedData) => {
						if (checkedData.id == offerData.id) {
							billCheckedOfferData.push(checkedData);
						}
					});
				});
			}
			dataToSave.push({
				outletBillHeader: header,
				offerHeaders: billCheckedOfferData,
				productAndStocks: stockChangedList,
			});
			return;
		}

		const afterOffers = billData.outletBillsAfterApplyingOffers;
		if (
			!hasHeader &&
			afterOffers &&
			Object.keys(afterOffers).length !== 0 &&
			afterOffers.id == billOfferId
		) {
			const billCheckedOfferData = [];
			if (billData.offerHeaders?.length !== 0) {
				billData.offerHeaders.forEach((offerData) => {
					checkboxAllData.forEach((checkedData) => {
						if (checkedData.id == offerData.id) {
							billCheckedOfferData.push(checkedData);
						}
					});
				});
			}
			dataToSave.push({
				outletBillsAfterApplyingOffers: afterOffers,
				offerHeaders: billCheckedOfferData,
				productAndStocks: stockChangedList,
			});
		}
	});

	return dataToSave[0];
};
